import { SYMBOL_PATH, WORDMARK_PATH } from "../../brand";
import { cn } from "@/lib/utils";

type BrandProps = React.SVGProps<SVGSVGElement> & {
  /** Render the symbol in currentColor too (e.g. white-on-blue panels). */
  mono?: boolean;
};

/** Full lockup: symbol + "aimdoc" wordmark. The wordmark follows `currentColor`. */
export function AimdocLogo({ mono = false, className, ...props }: BrandProps) {
  return (
    <svg
      viewBox="0 0 232 64"
      role="img"
      aria-label="Aimdoc"
      className={cn("h-8 w-auto", className)}
      {...props}
    >
      <path
        d={SYMBOL_PATH}
        fillRule="evenodd"
        fill={mono ? "currentColor" : undefined}
        className={mono ? undefined : "fill-[#1173F0] dark:fill-[#3B8BFF]"}
      />
      <path d={WORDMARK_PATH} fill="currentColor" />
    </svg>
  );
}

/** Symbol only. Brand blue by default; `mono` follows `currentColor`. */
export function AimdocSymbol({ mono = false, className, ...props }: BrandProps) {
  return (
    <svg viewBox="0 0 64 64" role="img" aria-label="Aimdoc" className={cn("h-6 w-6", className)} {...props}>
      <path
        d={SYMBOL_PATH}
        fillRule="evenodd"
        fill={mono ? "currentColor" : undefined}
        className={mono ? undefined : "fill-[#1173F0] dark:fill-[#3B8BFF]"}
      />
    </svg>
  );
}
